// extracted by mini-css-extract-plugin
export default {"hSplit":"divider_hSplit__QsTHY","vSplit":"divider_vSplit__zd4Ft"};